export default () => ({
  scrolled:false,hidden:false,lastY:0,timer:null,
  show(){this.hidden=false;clearTimeout(this.timer);},
  arm(){
    clearTimeout(this.timer);
    if(!this.scrolled)return;
    this.timer=setTimeout(()=>{
      if(!this.$el.matches(':hover,:focus-within')&&!this.$el.querySelector('details[open]'))this.hidden=true;
    },1500);
  },
  init(){
    this.lastY=Math.max(0,scrollY);
    this.update=()=>{
      if(this.$el.classList.contains('has-mobile-menu'))return;
      const y=Math.max(0,scrollY),up=y<this.lastY-2;
      this.scrolled=y>24;if(!this.scrolled||up)this.show();this.lastY=y;this.arm();
    };
    this.restore=()=>{this.show();this.update();};
    this.enter=()=>this.show();this.leave=()=>this.arm();
    this.restore();window.addEventListener('scroll',this.update,{passive:true});window.addEventListener('pageshow',this.restore);
    this.$el.addEventListener('pointerenter',this.enter);this.$el.addEventListener('pointerleave',this.leave);
    this.$el.addEventListener('focusin',this.enter);this.$el.addEventListener('focusout',this.leave);this.$el.addEventListener('toggle',this.leave,true);
  },
  destroy(){
    clearTimeout(this.timer);window.removeEventListener('scroll',this.update);window.removeEventListener('pageshow',this.restore);
    this.$el.removeEventListener('pointerenter',this.enter);this.$el.removeEventListener('pointerleave',this.leave);
    this.$el.removeEventListener('focusin',this.enter);this.$el.removeEventListener('focusout',this.leave);this.$el.removeEventListener('toggle',this.leave,true);
  },
});
